import { makeActions } from '@redux/crudCreator/actions';
import { formatFilter } from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLocationsApi, importLocationsApi } from 'api/configs';
import { DynamicObjectType } from 'types/commons';

export const MODEL_NAME = 'locations';
export const locationsActions = makeActions(MODEL_NAME, 'id');

export const getAllLocations = locationsActions.getAll;
export const editLocations = locationsActions.edit;
export const createLocations = locationsActions.create;
export const getByIdLocations = locationsActions.getDataById;

export const getMultipleLocationById = createAsyncThunk(
  'productCategories/patchProductCategoriesProducts',
  async (payload: DynamicObjectType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const convertRequest = {
        s: JSON.stringify(formatFilter(data?.filters || [])),
      };

      const response = await apiWrapper(
        { isShowSuccessNoti: false, ...options },
        getLocationsApi,
        convertRequest,
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const importLocations = createAsyncThunk(
  'locations/importLocations',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
          ...options,
        },
        importLocationsApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
